import React, { memo, useEffect } from 'react';

import SearchBox from '../../../general/gmb-local-posts/SearchBox';
import LocalPostList from '../../../general/gmb-local-posts/LocalPostList';

import { RequestCompany } from '../../../../requests/partner/companies';
import { RequestGmbLocation } from '../../../../requests/partner/gmb-locations';
import { RequestGmbLocalPost } from '../../../../requests/partner/gmb-local-posts';
import { useLocalPostSearch } from '../../../../hooks/useLocalPostSearch';

type Props = {
  specifiedCompanyId?: number;
  templatePath?: string;
  specifiedGmbLocationId?: number;
  paginationPath: string;
  isSyncing?: boolean;
  searchable?: boolean;
};

const PartnerLocalPostList: React.FC<Props> = (props) => {
  const { specifiedCompanyId, specifiedGmbLocationId, paginationPath, searchable, isSyncing } =
    props;

  const { isLoading, queries, pagination, gmbLocalPosts, refresh, handleSearch } =
    useLocalPostSearch({
      specifiedCompanyId,
      specifiedGmbLocationId,
      requestLocalPosts: RequestGmbLocalPost.list,
    });

  useEffect(() => {
    refresh(queries.currentPage, {
      topicType: queries.topicType,
      companyId: queries.companyId,
      gmbLocationId: queries.gmbLocationId,
    });
  }, [queries.currentPage, queries.topicType, queries.companyId, queries.gmbLocationId]);

  if (gmbLocalPosts === undefined) {
    return <></>;
  }
  return (
    <>
      <SearchBox
        selectedItems={{
          companyId: queries.companyId,
          gmbLocationId: queries.gmbLocationId,
          selectedTopicType: queries.topicType,
        }}
        searchableItem={['company', 'gmbLocation']}
        searchable={searchable === undefined ? true : searchable}
        refreshLocalPosts={refresh}
        isSyncing={isSyncing}
        handleCreateLocalPost={RequestGmbLocalPost.create}
        handleShowGmbLocation={RequestGmbLocation.show}
        handleCompanyRequest={RequestCompany.search}
        handleGmbLocationRequest={RequestGmbLocation.search}
        handleAfterSearch={handleSearch}
        handleGmbLocalPost={RequestGmbLocalPost.sync}
        handleGmbLocationKeyword={RequestGmbLocation.keywords}
      />
      <LocalPostList
        queries={queries}
        isLoading={isLoading}
        pagination={pagination}
        handleGmbLocationKeyword={RequestGmbLocation.keywords}
        handleShowGmbLocation={RequestGmbLocation.show}
        handleGmbLocalPostUpdate={RequestGmbLocalPost.update}
        handleGmbLocalPostDelete={RequestGmbLocalPost.destroy}
        gmbLocalPosts={gmbLocalPosts}
        searchable={searchable === undefined ? true : searchable}
        paginationPath={paginationPath}
        handleSearch={refresh}
      />
    </>
  );
};

export default memo(PartnerLocalPostList);
